import { Button, TechemLogo } from '@pkdigital/pkd-custom-components';
import * as React from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { TrackerUtil } from 'src/tracking/TrackerUtil';
import { useBranding } from '../../../hooks/useBranding';
import { Branding } from '../../../types';
import { useMediaQuery } from '../../../hooks';
import { md } from '../../../utils/media-queries';

const onClick = (e: React.MouseEvent<HTMLButtonElement>) => {
  // Tracking
  TrackerUtil.trackBtnClick(
    `td-home_button_${'header cta'.split('-')[0]}`,
    `button_${'header-cta'.split('-')[0]}`
  );

  e.preventDefault();
  const urlParams = new URLSearchParams(window.location.search);
  window.location.href = `/onboarding?${urlParams.toString()}`;
};

export function Header() {
  const { t } = useTranslation();
  const branding: Branding = useBranding();
  const isMdOrAbove = useMediaQuery(`(${md}`);

  return (
    <header id="header">
      <Container className="h-100">
        <Row className="h-100 g-0 justify-content-between">
          <Col xs={'auto'} className="align-self-center">
            {/* Hint: change this span to an "a" if you want a link with nice touch area */}
            <Row>
              <Col xs={'auto'} className="align-self-center">
                <a
                  href="https://www.techem.com/de/de"
                  onClick={() => {
                    TrackerUtil.trackLinkClick('header_link_logo', 'link_logo');
                  }}
                >
                  <div className="logo-wrapper">
                    <TechemLogo className="w-100" />
                  </div>
                </a>
              </Col>

              {branding === 'hug' && isMdOrAbove && (
                <Col xs={'auto'} className="align-self-center">
                  <img
                    src={'/td-home/images/hug-logo.png'}
                    style={{ maxHeight: 40 }}
                    alt={'hug-logo'}
                  />
                </Col>
              )}
            </Row>
          </Col>

          <Col xs={'auto'} className="align-self-center justify-content-end">
            <Button themeColor={branding === 'hug' ? 'secondary' : 'primary'} onClick={onClick}>
              {t(branding === 'hug' ? 'header.button.hug.title' : 'header.button.title')}
            </Button>
          </Col>
        </Row>
      </Container>
    </header>
  );
}
